import { cn, getInitials } from '@/lib/utils';

type AvatarVariant = 'coach' | 'director' | 'muted';
type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const variantStyles: Record<AvatarVariant, string> = {
  coach: 'bg-gradient-to-br from-clay-400 to-clay-600 text-white',
  director: 'bg-gradient-to-br from-purple-500 to-violet-500 text-white',
  muted: 'bg-muted text-muted-foreground',
};

const sizeStyles: Record<AvatarSize, string> = {
  xs: 'w-8 h-8 text-xs',
  sm: 'w-9 h-9 text-sm',
  md: 'w-10 h-10 text-sm',
  lg: 'w-14 h-14 text-lg',
  xl: 'w-20 h-20 text-3xl',
};

interface PlayerAvatarProps {
  firstName: string;
  lastName: string;
  variant?: AvatarVariant;
  size?: AvatarSize;
  className?: string;
}

export function PlayerAvatar({
  firstName,
  lastName,
  variant = 'coach',
  size = 'md',
  className,
}: PlayerAvatarProps) {
  return (
    <div
      className={cn(
        'rounded-full flex items-center justify-center font-bold flex-shrink-0',
        variantStyles[variant],
        sizeStyles[size],
        className,
      )}
    >
      {getInitials(firstName, lastName)}
    </div>
  );
}
